// extracted by mini-css-extract-plugin
export default {"background":"_9p6Ct","overlay":"+ttxB","mobile":"pHwMH"};